export default lang => {
  if (lang === 'fr') {
    return 'dddd DD MMMM YYYY'
  } else {
    return 'dddd DD MMMM YYYY'
  }
}
